import React from "react";

const UkReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of apostille for UK:</h3>
        <p>
          Authentication for the UK has its own prerequisite in the visa
          procedure & expansion of the business in UK. Apostille is required as
          it is among the countries that are a part of the Hague Convention
          which is known as the Apostille Convention.
        </p>
        <p>
          There are policies of UK that need documents with MEA sticker to allow
          a visitor to stay or perform business in their country. It is a part
          of security that indicates the trustworthiness of the documents.
          Therefore, certification of documents becomes a necessity for these
          reasons.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get Document Apostille:</h3>
        <p>
          The total time period required for Apostille services for UK depends
          on several aspects such as which state the certificate was issued
          from, or the types of documents, or the organization you require it
          from. Usually, it will take around 2-3 working days to accomplish the
          whole process of Apostille services in Bangalore for UK.
        </p>
      </div>
    </div>
  );
};

export default UkReqMain;
